/*
* PDA 页面路径枚举
* 参考 TmsPath 定义
*/
export enum PdaPath {
    // 发出
    PDA_SHIP_OUT = "/pda/ship-out",
    // 到达
    PDA_SHIP_IN = "/pda/ship-in",
    // TMS 到达
    PDA_TMS_ARRIVAL = "/pda/tms/arrival",
    // TMS 装车
    PDA_TMS_LOADING = "/pda/tms/loading",
    // TMS 装载信息
    PDA_TMS_LOADING_DETAIL = "/pda/tms/loading-detail",
    // TMS 封车
    PDA_TMS_SEALING = "/pda/tms/sealing",
    // TMS 解封车
    PDA_TMS_UNSEALING = "/pda/tms/unsealing",
    // TMS 发车
    PDA_TMS_DEPARTURE = "/pda/tms/departure",
    // TMS 卸车扫描
    PDA_TMS_UNLOADING = "/pda/tms/unloading",
    // TMS 卸车信息（支线流程入口）
    PDA_TMS_UNLOADING_DETAIL = "/pda/tms/unloading-detail",
    // TMS 卸车扫描流程-卸载信息（卸车扫描下一步）
    PDA_TMS_UNLOADING_INFO = "/pda/tms/unloading-info",
    // TMS 上传BOL
    PDA_TMS_UPLOAD_BOL = "/pda/tms/upload-bol",
    // TMS 卸车包牌明细（应卸/实卸/未卸）
    PDA_TMS_UNLOADING_BAG_DETAIL = "/pda/tms/unloading-bag-detail",
}

